import Spinner from '../Spinner/Spinner';
import styles from './Loader.module.sass';

export enum LOADER_SIZE {
    LARGE = 'large',
    MEDIUM = 'medium',
    SMALL = 'small'
}

interface LoaderProps {
    description?: string
    size?: LOADER_SIZE | 'small' | 'medium' | 'large'
}

const Loader = ({description, size}: LoaderProps) => {
    return <div className={styles.loader}>
        <Spinner />
        { description && <strong>{ description }</strong> }
    </div>;
}

export default Loader;